import * as PhosphorIcons from "@phosphor-icons/react";
import {
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
  TooltipProvider,
} from "@replicate/ui";
import type React from "react";

export default function IconTooltip({
  icon,
  tooltipText,
  tooltipClass = "",
  anchorClass = "",
  placement = "top",
  weight = "fill",
  size = 16,
}: {
  icon: string;
  tooltipText: React.ReactNode;
  tooltipClass?: string;
  anchorClass?: string;
  placement?: "top" | "bottom" | "left" | "right";
  weight?: "fill" | "light" | "regular" | "duotone" | "thin" | "bold";
  size?: number;
}) {
  const Icon = PhosphorIcons[icon];
  if (!Icon) {
    console.warn(`${icon} not found`);
    return null;
  }
  return (
    <TooltipProvider placement={placement} showTimeout={0}>
      <TooltipAnchor
        render={
          <Icon
            size={size}
            weight={weight}
            className={`inline ${anchorClass}`}
          />
        }
      />
      <Tooltip
        unmountOnHide
        className={`max-w-48 text-r8-xs z-50 ${tooltipClass}`}
      >
        <TooltipArrow className="fill-black dark:fill-white" />
        {tooltipText}
      </Tooltip>
    </TooltipProvider>
  );
}
